export const stringUtils = (str: string): string => {
  return str
    .split(' ')
    .filter(Boolean)
    .map(word => {
      const first = word.charAt(0).toUpperCase();
      const rest = word.slice(1).toLowerCase();
      return first + rest;
    })
    .join(' ');
}
